import { Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { isEmpty } from 'lodash-es';

export interface MainToolbarHeaderInfoItem {
    label: string;
    value: string;
}

export interface MainToolbarHeaderInfo {
    mainDescription: string;
    secondaryDescription: string;
    infoList: MainToolbarHeaderInfoItem[];
}

@Component({
    selector: 'se-header-info',
    templateUrl: './se-header-info.component.html',
    styleUrls: ['./se-header-info.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SeHeaderInfoComponent {
    @Input() info: MainToolbarHeaderInfo;

    @ViewChild('mainDescription') mainDescription!: ElementRef;
    @ViewChild('infoContainer') infoContainer!: ElementRef;


    get isInfoEmpty():boolean {
        return !this.info || !this.info.infoList || this.info.infoList.length == 0;
    }

    get isMultilineButton(): boolean {
        return this.info && !isEmpty(this.info.secondaryDescription);
    }

    onMouseEnter() {
        setTimeout(() => {
            const element = this.mainDescription.nativeElement;
            if (element.offsetWidth < element.scrollWidth) {
                this.infoContainer.nativeElement.setAttribute('title', element.textContent);
            }
            else if (this.infoContainer.nativeElement.title) this.infoContainer.nativeElement.removeAttribute('title');
        }, 50);

    }
}
